import { CurrencyOrEmpty } from '@/components/typography/currency-or-empty';
import { DataText } from '@/components/typography/data-text';
import { DeltaText } from '@/components/typography/delta-text';
import { DeltaTriangle } from '@/components/typography/delta-triangle';
import { NumberOrEmpty } from '@/components/typography/number-or-empty';
import { PercentageOrEmpty } from '@/components/typography/percentage-or-empty';
import { MaskedContent } from '@/features/customer-mode/components/masked-content';
import React from 'react';
import { DoubleDeckerCell } from './double-decker-cell';

export const DeltaDoubleDeckerCell = ({
    percentage,
    amount,
    masked = false,
    style = 'currency',
}: {
    percentage: number | null;
    amount: number | null;
    style?: 'currency' | 'number';
    masked?: boolean;
}) => {
    const diff = percentage;
    const up = diff === 0 || diff === null ? null : diff > 0;

    const Masked = masked ? MaskedContent : React.Fragment;
    const DataStyleComponent = style === 'currency' ? CurrencyOrEmpty : NumberOrEmpty;

    return (
        <DoubleDeckerCell
            topLevel={
                <Masked>
                    <DataText>
                        <DeltaText up={up}>
                            <PercentageOrEmpty showEmptyIfZero showPlusSignIfPositive>
                                {percentage}
                            </PercentageOrEmpty>
                            {up !== null && <DeltaTriangle up={up} />}
                        </DeltaText>
                    </DataText>
                </Masked>
            }
            bottomLevel={
                <Masked>
                    <DataText>
                        <DataStyleComponent showEmptyIfZero showPlusSignIfPositive>
                            {amount}
                        </DataStyleComponent>
                    </DataText>
                </Masked>
            }
        />
    );
};
